import { JSX } from "react";
import achievedImage from "../../../../common/images/achieved.svg";
import {
    TableWidget,
    EmptyWidget,
} from "@hatch-digital-nl/abs-storybook/legacy";
import Skeleton from "react-loading-skeleton";
import { useDashboardAchievedCertificates } from "../../hooks/useDashboardAchievedCertificates";

export const DashboardAchievedCertificates = (): JSX.Element => {
    const {
        loading,
        table,
        currentPage,
        itemsPerPage,
        itemsPerPageSelect,
        onPageChange,
        onItemsPerPageChange,
        title,
        isEmpty,
    } = useDashboardAchievedCertificates();

    if (loading) {
        return <Skeleton height={"35rem"} borderRadius={"1.5rem"} />;
    }

    if (isEmpty) {
        return (
            <EmptyWidget
                title={title}
                content={"Geen behaalde certificaten"}
                svgUrl={achievedImage}
            />
        );
    }

    return (
        <TableWidget
            data={table}
            showResultCount={true}
            totalItemsInTitle={false}
            svgUrl={achievedImage}
            title={title}
            currentPage={currentPage}
            onChange={onPageChange}
            itemsPerPage={itemsPerPage}
            itemsPerPageSelect={itemsPerPageSelect}
            onItemsPerPageChange={onItemsPerPageChange}
            lastColumnAlignRight
        />
    );
};
